module.exports = __webpack_public_path__ + "static/img/logo_3.81ced98c.png";